import { AUTH_URL } from "@shared/constants";

import { authPut } from "./auth";

export const refreshIdentity = (): Promise<{ token: string }> =>
  authPut<Record<string, never>, { token: string }>(`${AUTH_URL}/refresh`, {});
